import type { DeleteCageVariables, UseDeleteCageResult } from '@/domain/cages/types';
import type { DomainMutationOptions } from '@/domain/shared/types';
import { useCageController_deleteCage } from '@/services/hooks';

import { ignoreBody, useMappedMutation } from '../shared/mutation';

type UseDeleteCageOptions = DomainMutationOptions<
    {
        cageId: number;
    },
    void
>;

function deleteCageToApi(variables: DeleteCageVariables) {
    return { cageId: variables.cageId };
}

export const useDeleteCage = (options?: UseDeleteCageOptions): UseDeleteCageResult =>
    useMappedMutation(useCageController_deleteCage(options), deleteCageToApi, ignoreBody);
